import { iconSizeToZoomMap } from 'sharedMapComponents/GenericMarker/constants';

export const getIconSizes = (zoom: number) => {
	const DEFAULT_ANCHOR_VALUE_FACTOR = 2.5;
	const DEFAULT_ICON_SIZE_FACTOR = 2;
	return {
		extraExtraSmall: {
			anchor: new google.maps.Point(
				parseFloat(
					`${
						6 /
						(iconSizeToZoomMap[`${zoom}`]?.anchorValueFactor ??
							DEFAULT_ANCHOR_VALUE_FACTOR)
					}`,
				),
				parseFloat(
					`${
						6 /
						(iconSizeToZoomMap[`${zoom}`]?.anchorValueFactor ??
							DEFAULT_ANCHOR_VALUE_FACTOR)
					}`,
				),
			),
			scaledSize: new google.maps.Size(
				12 /
					(iconSizeToZoomMap[`${zoom}`]?.iconSizeFactor ??
						DEFAULT_ICON_SIZE_FACTOR),
				12 /
					(iconSizeToZoomMap[`${zoom}`]?.iconSizeFactor ??
						DEFAULT_ICON_SIZE_FACTOR),
			),
		},
		extraSmall: {
			anchor: new google.maps.Point(
				parseFloat(
					`${
						10 /
						(iconSizeToZoomMap[`${zoom}`]?.anchorValueFactor ??
							DEFAULT_ANCHOR_VALUE_FACTOR)
					}`,
				),
				parseFloat(
					`${
						10 /
						(iconSizeToZoomMap[`${zoom}`]?.anchorValueFactor ??
							DEFAULT_ANCHOR_VALUE_FACTOR)
					}`,
				),
			),
			scaledSize: new google.maps.Size(
				20 /
					(iconSizeToZoomMap[`${zoom}`]?.iconSizeFactor ??
						DEFAULT_ICON_SIZE_FACTOR),
				20 /
					(iconSizeToZoomMap[`${zoom}`]?.iconSizeFactor ??
						DEFAULT_ICON_SIZE_FACTOR),
			),
		},
		small: {
			anchor: new google.maps.Point(
				parseFloat(
					`${
						14 /
						(iconSizeToZoomMap[`${zoom}`]?.anchorValueFactor ??
							DEFAULT_ANCHOR_VALUE_FACTOR)
					}`,
				),
				parseFloat(
					`${
						14 /
						(iconSizeToZoomMap[`${zoom}`]?.anchorValueFactor ??
							DEFAULT_ANCHOR_VALUE_FACTOR)
					}`,
				),
			),
			scaledSize: new google.maps.Size(
				26 /
					(iconSizeToZoomMap[`${zoom}`]?.iconSizeFactor ??
						DEFAULT_ICON_SIZE_FACTOR),
				26 /
					(iconSizeToZoomMap[`${zoom}`]?.iconSizeFactor ??
						DEFAULT_ICON_SIZE_FACTOR),
			),
		},
		medium: {
			anchor: new google.maps.Point(
				parseFloat(
					`${
						18 /
						(iconSizeToZoomMap[`${zoom}`]?.anchorValueFactor ??
							DEFAULT_ANCHOR_VALUE_FACTOR)
					}`,
				),
				parseFloat(
					`${
						18 /
						(iconSizeToZoomMap[`${zoom}`]?.anchorValueFactor ??
							DEFAULT_ANCHOR_VALUE_FACTOR)
					}`,
				),
			),
			scaledSize: new google.maps.Size(
				26 /
					(iconSizeToZoomMap[`${zoom}`]?.iconSizeFactor ??
						DEFAULT_ICON_SIZE_FACTOR),
				26 /
					(iconSizeToZoomMap[`${zoom}`]?.iconSizeFactor ??
						DEFAULT_ICON_SIZE_FACTOR),
			),
		},
		large: {
			anchor: new google.maps.Point(
				parseFloat(
					`${
						23 /
						(iconSizeToZoomMap[`${zoom}`]?.anchorValueFactor ??
							DEFAULT_ANCHOR_VALUE_FACTOR)
					}`,
				),
				parseFloat(
					`${
						23 /
						(iconSizeToZoomMap[`${zoom}`]?.anchorValueFactor ??
							DEFAULT_ANCHOR_VALUE_FACTOR)
					}`,
				),
			),
			scaledSize: new google.maps.Size(
				34 /
					(iconSizeToZoomMap[`${zoom}`]?.iconSizeFactor ??
						DEFAULT_ICON_SIZE_FACTOR),
				32 /
					(iconSizeToZoomMap[`${zoom}`]?.iconSizeFactor ??
						DEFAULT_ICON_SIZE_FACTOR),
			),
		},
		extraLarge: {
			anchor: new google.maps.Point(
				parseFloat(
					`${
						28 /
						(iconSizeToZoomMap[`${zoom}`]?.anchorValueFactor ??
							DEFAULT_ANCHOR_VALUE_FACTOR)
					}`,
				),
				parseFloat(
					`${
						28 /
						(iconSizeToZoomMap[`${zoom}`]?.anchorValueFactor ??
							DEFAULT_ANCHOR_VALUE_FACTOR)
					}`,
				),
			),
			scaledSize: new google.maps.Size(
				40 /
					(iconSizeToZoomMap[`${zoom}`]?.iconSizeFactor ??
						DEFAULT_ICON_SIZE_FACTOR),
				40 /
					(iconSizeToZoomMap[`${zoom}`]?.iconSizeFactor ??
						DEFAULT_ICON_SIZE_FACTOR),
			),
		},
		extraExtraLarge: {
			anchor: new google.maps.Point(
				parseFloat(
					`${
						30 /
						(iconSizeToZoomMap[`${zoom}`]?.anchorValueFactor ??
							DEFAULT_ANCHOR_VALUE_FACTOR)
					}`,
				),
				parseFloat(
					`${
						30 /
						(iconSizeToZoomMap[`${zoom}`]?.anchorValueFactor ??
							DEFAULT_ANCHOR_VALUE_FACTOR)
					}`,
				),
			),
			scaledSize: new google.maps.Size(
				34 /
					(iconSizeToZoomMap[`${zoom}`]?.iconSizeFactor ??
						DEFAULT_ICON_SIZE_FACTOR),
				34 /
					(iconSizeToZoomMap[`${zoom}`]?.iconSizeFactor ??
						DEFAULT_ICON_SIZE_FACTOR),
			),
		},
	};
};
